import { render, staticRenderFns } from "./BuyerForm.vue?vue&type=template&id=5da781ea"
import script from "./BuyerForm.vue?vue&type=script&lang=js"
export * from "./BuyerForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports